import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePlatformMenuItemMutation } from "../graphql/mutations";

export const useUpdatePlatformMenuItemMutation = (
  options?: MutationHookOptions<any, any>
) => {
  return useMutation<any, any>(UpdatePlatformMenuItemMutation, options);
};
